<template>
  <div id="contrato-data">
    <v-layout>
      <v-flex>
        <!-- TIPO VISITA -->
        <v-select
          v-if="tipeView != 'oculto'"
          v-model="tipoVisitaValue"
          :items="tipoVisitaSelect"
          item-text="nombre"
          item-value="code"
          :error-messages="tipoVisitaSelectErrors"
          label="Tipo de visita"
          :box="tipeView != 'crear'"
          :readonly="tipeView != 'crear'"
          @input="$v.tipoVisitaValue.$touch()"
          @blur="tipeView == 'crear' ? $v.tipoVisitaValue.$touch() : null"
        ></v-select>
        <!-- ESTADO VISITA -->
        <v-select
          v-if="tipeView != 'crear'"
          v-model="estadoVisitaValue"
          :items="estadoVisitaSelect"
          item-text="nombre"
          item-value="code"
          :error-messages="estadoVisitaSelectErrors"
          label="Estado"
          :box="tipeView == 'consulta'"
          :readonly="tipeView == 'consulta'"
          @change="setEstadoVisita"
          @input="$v.estadoVisitaValue.$touch()"
          @blur="tipeView == 'crear' ? $v.estadoVisitaValue.$touch() : null"
        ></v-select>
        <!-- FECHA DE INGRESO ----- ESTA FECHA ES CARGADA POR BACK -->
        <v-text-field
          v-model="fechaIngreso"
          label="Fecha Ingreso"
          prepend-icon="event"
          :readonly="tipeView != ''"
          :box="tipeView != ''"
          v-on="on"
        ></v-text-field>
        <!-- FECHA VISITA -->
        <v-flex xs12 md4>
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fechaVisita"
                label="Fecha Visita"
                prepend-icon="event"
                :readonly="
                  tipeView == 'consulta' ||
                  (tipeView == 'modifica' &&
                    fechaVisita != null &&
                    fechaVisita != '' &&
                    fechaVisita != undefined)
                "
                :box="
                  tipeView == 'consulta' ||
                  (tipeView == 'modifica' &&
                    fechaVisita != null &&
                    fechaVisita != '' &&
                    fechaVisita != undefined)
                "
                @input="setEstadoVisita"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaVisita"
              no-title
              @input="menu1 = false"
              @change="setEstadoVisita"
              locale="es"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <!-- ADJUNTOS -->
        <data-adjunto
          v-if="tipeView != 'consulta'"
          :tipeArchive="tipeArchive"
        ></data-adjunto>

        <!-- OBSERVACIONES -->
        <v-flex xs12>
          <v-textarea
            v-if="tipeView != 'consulta'"
            v-model="observacion"
            :error-messages="observacionErrors"
            label="Observaciones"
            :readonly="tipeView == 'consulta'"
            :box="tipeView == 'consulta'"
            @input="$v.observacion.$touch()"
            @blur="tipeView == 'crear' ? $v.observacion.$touch() : null"
          ></v-textarea>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-card-actions class="pb-3">
      <v-btn
        v-if="tipeView == 'crear'"
        color="primary"
        dark
        class="mb-2"
        @click="saveVisit"
      >
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn>
      <v-btn
        v-if="tipeView == 'modifica'"
        color="primary"
        dark
        class="mb-2"
        @click="editVisit"
      >
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import DataAdjunto from "@/components/AdjuntoData.vue";
import axios from "axios";
import { error, isNull } from "util";
import { async } from "q";
export default {
  name: "contrato-data",
  components: {
    DataAdjunto,
  },
  mixins: [validationMixin],
  props: {
    tipeView: "",
    contratoId: "",
    base64Value: "",
    filenameValue: "",
    idVisita: "",
  },
  data() {
    return {
      tipoVisitaValue: "",
      tipoVisitaSelect: [],
      estadoVisitaValue: "",
      estadoVisitaSelect: [],
      //tipoVisita:"",
      idVisitaValue: "",
      allowSpaces: false,
      fechaVisita: new Date().toISOString().substr(0, 10),
      fechaIngreso: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      codigo: "",
      contratoId: "",
      idUsuario: "",
      observacion: "",
      estado: "",
      visita: [],
      visitaFile: "",
      files: [],
      file: "",
      base64Value: "",
      filenameValue: "",
      tipeArchive: "",
    };
  },

  mixins: [validationMixin],
  validations: {
    tipoVisitaValue: { required },
    estadoValue: { required },
    fechaIngreso: { required },
    fechaVisita: { required },
    fichero: { required },
    observacion: { required },
  },

  created() {
    this.contratoId = this.$store.getters.contratoStored;
    this.idUsuario = this.$store.getters.userLogged.id;
    this.idVisita = this.$store.getters.visitaStored;
    this.tipeView = this.$route.params.tipeView;
    this.tipeArchive = ".pdf";
  },

  mounted() {
    //llamar a la api de contratos para listar contratos
    this.idVisita = this.$store.getters.visitaStored;
    this.contratoId = this.$store.getters.contratoStored;
    this.tipeView = this.$route.params.tipeView;
    if (this.tipeView == "consulta" || this.tipeView == "modifica") {
      this.loadData();
    }
    if (this.tipeView == "crear") {
      this.fechaVisita = "";
      this.setEstadoVisita();
      this.loadDataTipo();
    }
  },
  computed: {
    tipoVisitaSelectErrors() {
      const errors = [];
      if (!this.$v.tipoVisitaValue.$dirty) return errors;
      !this.$v.tipoVisitaValue.required && errors.push("Item is required");
      return errors;
    },
    tipoVisitaSelectErrors() {
      const errors = [];
      if (!this.$v.tipoVisitaValue.$dirty) return errors;
      !this.$v.tipoVisitaValue.required && errors.push("Item is required");
      return errors;
    },
    isDisabled() {
      if (this.tipeView && this.tipeView == "consulta") {
        return true;
      }
    },
  },
  methods: {
    setEstadoVisita() {
      if (this.tipeView != "modifica") {
        if (this.fechaVisita != "") {
          this.estadoVisitaValue = "PENDIENTE";
        } else {
          this.estadoVisitaValue = "INICIAL";
        }
      }
    },
    formatoFecha(f) {
      // Convierte un texto de la forma 2017/01/10 a la forma
      return f.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3-$2-$1");
    },
    async saveVisit() {
      this.$v.$touch();
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;
      let est;
      let fechaVisitaFormat = this.formatoFecha(this.fechaVisita);
      this.userLogged = this.$store.getters.userLogged.id;
      this.contratoId = this.$store.getters.contratoStored;
      let base64EncodedStr = this.base64Value;
      let tip = this.tipoVisitaValue;
      if (Array.isArray(tip)) {
        window.getApp.$emit(
          "ERROR_EXCEPTION",
          "Debes seleccionar un tipo de visita"
        );
        return;
      }
      if (this.fechaVisita != "") {
        est = 2;
      } else {
        window.getApp.$emit(
          "ERROR_EXCEPTION",
          "Debes introducir la fecha de la visita"
        );
        return;
      }
      this.body = {
        // idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
        fechaVisita: fechaVisitaFormat,
        estadoVisita: { id: est },
        tipoVisita: { id: tip },
        filename: this.filenameValue,
        documento: base64EncodedStr,
        observaciones: this.observacion,
      };
      axios
        .post("/visita", this.body)
        .then((res) => {
          this.resp = res.data;
          window.getApp.$emit("APP_SAVE");
          this.back();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
        });
    },

    async editVisit(e) {
      this.$v.$touch();
      let fechaVisitaFormat = this.formatoFecha(this.fechaVisita);
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;
      let base64EncodedStr = this.base64Value;
      let tip = this.tipoVisitaValue;
      let est = this.estadoVisitaValue;
      this.body = {
        fechaVisita: fechaVisitaFormat,
        estadoVisita: { id: est },
        tipoVisita: { id: tip.code },
        filename: this.filenameValue,
        documento: base64EncodedStr,
        observaciones: this.observacion,
        // idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
      };
      axios
        .put("/visita/" + this.idVisitaValue, this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.back();
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          console.log(error);
        });
    },

    submit() {
      this.$v.$touch();
    },
    resetForm() {
      this.form = Object.assign({}, this.defaultForm);
      this.$refs.form.reset();
    },
    submit() {
      this.resetForm();
    },

    async loadData() {
      this.visita = await this.loadVisitaData();

      this.tipoVisitaValue = {
        nombre: this.visita.tipoVisita.descripcion,
        code: this.visita.tipoVisita.id,
      };

      this.tipoVisitaSelect = [
        {
          nombre: this.visita.tipoVisita.descripcion,
          code: this.visita.tipoVisita.id,
        },
      ];
      if (
        this.tipeView == "consulta" ||
        this.visita.fechaVisita == "" ||
        this.visita.fechaVisita == null ||
        this.visita.fechaVisita == undefined
      ) {
        this.estadoVisitaValue = {
          nombre: this.visita.estadoVisita.descripcion,
          code: this.visita.estadoVisita.id,
        };

        this.estadoVisitaSelect = [
          {
            nombre: this.visita.estadoVisita.descripcion,
            code: this.visita.estadoVisita.id,
          },
        ];
      } else {
        this.loadDataEstado();
      }
      this.fechaVisita = this.visita.fechaVisita;
      this.observacion = this.visita.observaciones;
      this.idVisitaValue = this.visita.id;
    },

    async loadVisitaData() {
      let that = this;

      return await axios
        .get(
          "/visita/" +
            this.idVisita +
            "/" +
            this.contratoId +
            "/" +
            this.idUsuario
        )
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadDataTipo() {
      this.genTipoVisita = await this.loadTipoVisita();
      let tipo = [];
      this.genTipoVisita.forEach(function (t) {
        tipo.push({
          nombre: t.descripcion,
          code: t.id,
        });
      });
      this.tipoVisitaSelect = tipo;
      this.tipoVisitaValue = this.tipoVisitaSelect;
    },

    async loadDataEstado() {
      this.genEstadoVisita = await this.loadEstadoVisita();
      let estado = [];
      this.genEstadoVisita.forEach(function (e) {
        estado.push({
          nombre: e.descripcion,
          code: e.id,
        });
      });
      this.estadoVisitaSelect = estado;
    },

    async loadTipoVisita() {
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        idContrato: idContrato,
      };
      return await axios
        .get("/tipo_visitas", this.body)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadEstadoVisita() {
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        idContrato: idContrato,
      };
      return await axios
        .get("/estado_visitas", this.body)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    back() {
      setTimeout(() => {
        this.$router.go(-1);
      }, 1000);
    },
  },
};
</script>
